const availableChars = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz'; // https://github.com/meteor/meteor/blob/master/packages/random/random.js#L88
const length = 17;

/** @deprecated Use randomId instead */
export function randomClientId() {
  return randomId();
}

// Note, not cryptograhically or database secure, just imitating the output of Meteor's Random.id()
// generate a 17 character random string
// TODO: prevent collisions
export function randomId() {
  const randomArray = new Array(length)
    .fill(0)
    .map(() => availableChars[Math.floor(Math.random() * availableChars.length)]);
  return randomArray.join('');
}

export function randomIds(count: number): string[] {
  const ids = new Set<string>();
  while (ids.size < count) {
    ids.add(randomId());
  }
  return Array.from(ids);
}
